import type { PaletteKey } from '@/shared/tweaks-defaults';

type PaletteVars = {
  '--ink': string;
  '--navy': string;
  '--navy-2': string;
  '--paper': string;
  '--paper-2': string;
  '--sand': string;
  '--coral': string;
  '--coral-2': string;
  '--leaf': string;
};

export const PALETTES: Record<
  PaletteKey,
  { label: string; swatch: [string, string, string]; vars: PaletteVars }
> = {
  globe: {
    label: 'Globe-traveler',
    swatch: ['#0E1B33', '#E8D5AC', '#E76F51'],
    vars: {
      '--ink': '#0E1B33',
      '--navy': '#14315B',
      '--navy-2': '#1E4170',
      '--paper': '#FAF5EA',
      '--paper-2': '#F4EAD2',
      '--sand': '#E8D5AC',
      '--coral': '#E76F51',
      '--coral-2': '#C24A2F',
      '--leaf': '#2E5E47',
    },
  },
  passport: {
    label: 'Passport',
    swatch: ['#1B1816', '#F2E9D8', '#C8362A'],
    vars: {
      '--ink': '#1B1816',
      '--navy': '#3E3528',
      '--navy-2': '#564A38',
      '--paper': '#F8F1DF',
      '--paper-2': '#EFE3C7',
      '--sand': '#E5D5B0',
      '--coral': '#C8362A',
      '--coral-2': '#9B271E',
      '--leaf': '#3A6647',
    },
  },
  departures: {
    label: 'Departures',
    swatch: ['#16161A', '#F4EFE6', '#E89B2A'],
    vars: {
      '--ink': '#16161A',
      '--navy': '#2A2A30',
      '--navy-2': '#3A3A42',
      '--paper': '#F4EFE6',
      '--paper-2': '#EAE2D2',
      '--sand': '#E4D9C0',
      '--coral': '#E89B2A',
      '--coral-2': '#B97A1B',
      '--leaf': '#4A6E3F',
    },
  },
  coastal: {
    label: 'Coastal',
    swatch: ['#0B3B47', '#FFF8E7', '#F2B340'],
    vars: {
      '--ink': '#0B3B47',
      '--navy': '#155C6C',
      '--navy-2': '#1C7888',
      '--paper': '#FFF8E7',
      '--paper-2': '#FCEFC9',
      '--sand': '#F4E3B4',
      '--coral': '#F2B340',
      '--coral-2': '#C88515',
      '--leaf': '#3A7D67',
    },
  },
};

export function applyPalette(documentElement: HTMLElement, key: PaletteKey): void {
  const palette = PALETTES[key];
  if (!palette) return;
  for (const [varName, value] of Object.entries(palette.vars)) {
    documentElement.style.setProperty(varName, value);
  }
}
